let initialized = false;
export function isInitialized() {
  return initialized;
}

export function setInitialized(value: boolean) {
  initialized = value;
}
